export const SET_MARKERS = 'SET_MARKERS';
export const SET_ORIGIN_MARKER = 'SET_ORIGIN_MARKER';
export const SET_SELECTED_MARKER = 'SET_SELECTED_MARKER';
export const SET_FILTERED_MARKERS = 'SET_FILTERED_MARKERS';
export const GET_MARKERS_REQUEST = 'GET_MARKERS_REQUEST';
export const GET_MARKERS_FAIL = 'GET_MARKERS_FAIL';